// extracted by mini-css-extract-plugin
export default {"NoteControl":"LgJJs","noteContainer":"qsry9","title":"kSARW","active":"I1XU9","speakerNotes":"yZ5hy","hidden":"bGC52","noNotes":"N1K4r","noteBtnTitle":"sWGb7","noteBtnDesc":"g2HSV"};